const API_URL = 'https://api.dtapex.com/api/';

export {
    API_URL
}
